import * as React from 'react';
import PropTypes from 'prop-types';
import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { grey } from '@mui/material/colors';
import Typography from '@mui/material/Typography';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

const drawerBleeding = 145;

const Root = styled('div')(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.palette.mode === 'dark'
    ? theme.palette.background.default
    : grey[100],
  zIndex: 1201, // Ensure LeadsDrawer is behind bottom nav
  position: 'relative',
}));

const StyledBox = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark'
    ? grey[800]
    : '#fff',
}));

const Puller = styled('div')(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: theme.palette.mode === 'dark'
    ? grey[900]
    : grey[300],
  borderRadius: 3,
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 15px)',
}));

function SwipeableEdgeDrawer(props) {
  const { window, children, status, count, showBackdrop, open, setOpen } = props;
  // Remove the open button and local open state
  // The drawer should be closed by default and openable by swipe only
  // const [open, setOpen] = React.useState(false); // REMOVE THIS

  // This is used only for the example
  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <CssBaseline />
      <Global
        styles={{
          '.MuiDrawer-root > .MuiPaper-root': {
            height: `calc(50% - ${drawerBleeding}px)`,
            overflow: 'visible',
          },
        }}
      />
      {/* Remove the open button */}
      <SwipeableDrawer
        container={container}
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        keepMounted
        PaperProps={{ sx: { zIndex: 1200 } }}
        ModalProps={{
          BackdropProps: {
            style: {
              backgroundColor: showBackdrop ? 'rgba(0,0,0,0.5)' : 'transparent'
            }
          }
        }}
      >
        <StyledBox
          sx={{
            position: 'absolute',
            top: -drawerBleeding,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            visibility: 'visible',
            right: 0,
            left: 0,
            paddingBottom: 5,
          }}
        >
          <Puller />
          <Typography sx={{ p: 2, color: 'text.secondary' }}>
            {status === 1 ? `Your Leads - ${count}` : null}
            {status === 2 ? `Your Deals - ${count}` : null}
            {status === 0 ? 'Prospecting' : null}
          </Typography>
        </StyledBox>
        <StyledBox sx={{ px: 2, pb: 2, height: '100%', position: 'absolute', top: -89, left: 0, width: '100%', overflow: 'hidden' }}>
          {children}
        </StyledBox>
      </SwipeableDrawer>
    </>
  );
}

SwipeableEdgeDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
  status: PropTypes.number,
  count: PropTypes.number,
  children: PropTypes.node,
  showBackdrop: PropTypes.bool,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

export default SwipeableEdgeDrawer;